import React from "react";
import { Radio } from "antd";
import style from "./style.scss";
import ColorPreview from "./ColorPreview";

const ReversedRadio = ({ color, label, ...props }) => (
  <Radio className={style.radio} {...props}>
    {/* <ColorPreview color={color} /> */}
    {label}
  </Radio>
);

export default ReversedRadio;



// WEBPACK FOOTER //
// ./src/components/FormControls/SingleColorSelector/MobileDropdownSelect/SingleSelectModal/ReversedRadio/index.tsx